import { Article, CopyAll } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import { GetAlertData } from "contexts/AlertContext";
import { GetCode } from "contexts/CodeContext";
import { GetData } from "contexts/DataContext";
import React from "react";

export function OrderField(props) {
  const { code } = GetCode();
  const { dataObj } = GetData();
  const { setAlert } = GetAlertData();
  return (
    <React.Fragment>
      {code.orderUrl && (
        <TextField
          InputProps={{
            disabled: true,
            style: {
              fontSize: dataObj?.deviceWidth?.isMobile ? "0.875rem" : "1rem",
            },
            startAdornment: (
              <InputAdornment position="start">
                <Article />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment
                position="end"
                onClick={() => {
                  navigator.clipboard.writeText(code?.orderID);
                  setAlert("Скопировано..");
                }}
              >
                <CopyAll />
              </InputAdornment>
            ),
          }}
          fullWidth
          label="Идентификатор документа"
          mb={2}
          mt={2}
          name="order"
          placeholder="Введите новый пин-код..."
          sx={{ margin: "0.875rem 0" }}
          type="text"
          value={code?.orderID || ""}
          variant="standard"
        />
      )}
    </React.Fragment>
  );
}
